module.exports = __webpack_public_path__ + "static/media/mars-double.924d4873.svg";